module.exports = new __parcel__URL__("mario-kart-super-circuit.bf060a88.jpg").toString();